import(/* webpackMode: "eager" */ "/home/ubuntu/download/6988d61b187bbe0013f2067c/website_project/src/app/wizard/page.tsx");
